import ApplicationList from "./ApplicationList";
import ApplicationShow from "./ApplicationShow";

const Application = { list: ApplicationList, show: ApplicationShow };

export default Application;
